// @ts-ignore
/* eslint-disable */
import { request } from '@/services/transit.request';

/** Get all transit service packages GET /api/v1/anvui/transit-service-packages */
export async function transitServicePackagesListWithPaging2(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitServicePackagesListWithPagingParams,
  options?: { [key: string]: any },
) {
  return request<API.TransitServicePackage[]>(
    '/api/v1/anvui/transit-service-packages',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** Get all transit service packages GET /api/v1/crm/transit-service-packages */
export async function transitServicePackagesListWithPaging(options?: {
  [key: string]: any;
}) {
  return request<API.ListTransitServicePackageDto>(
    '/api/v1/crm/transit-service-packages',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** Create a new transit service package POST /api/v1/crm/transit-service-packages */
export async function transitServicePackagesCreate(
  body: API.CreateTransitServicePackageDto,
  options?: { [key: string]: any },
) {
  return request<API.TransitServicePackage>(
    '/api/v1/crm/transit-service-packages',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** Get a transit service package by ID GET /api/v1/crm/transit-service-packages/${param0} */
export async function transitServicePackagesGetById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitServicePackagesGetByIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.TransitServicePackage>(
    `/api/v1/crm/transit-service-packages/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** Update a transit service package by ID PUT /api/v1/crm/transit-service-packages/${param0} */
export async function transitServicePackagesUpdateById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitServicePackagesUpdateByIdParams,
  body: API.UpdateTransitServicePackageDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.UpdateManyResultDto>(
    `/api/v1/crm/transit-service-packages/${param0}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    },
  );
}

/** Delete a transit service package by ID (soft delete) DELETE /api/v1/crm/transit-service-packages/${param0} */
export async function transitServicePackagesDeleteById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitServicePackagesDeleteByIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/crm/transit-service-packages/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Set active status of a transit service package by ID PUT /api/v1/crm/transit-service-packages/${param0}/active */
export async function transitServicePackagesSetActiveById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitServicePackagesSetActiveByIdParams,
  body: API.UpdateTransitServicePackageActiveDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.UpdateManyResultDto>(
    `/api/v1/crm/transit-service-packages/${param0}/active`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    },
  );
}
